import { render } from "./VISITOR_VALIDATION.vue?vue&type=template&id=2b637a88&scoped=true"
import script from "./VISITOR_VALIDATION.vue?vue&type=script&lang=js"
export * from "./VISITOR_VALIDATION.vue?vue&type=script&lang=js"

import "./VISITOR_VALIDATION.vue?vue&type=style&index=0&id=2b637a88&scoped=true&lang=css"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-kiosk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b637a88"]])

export default __exports__